import { ChangeEvent, FC, MouseEvent, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../hooks/ReduxHooks";
import { addSMS } from "../../../redux/requests/SMSRequest";
import { ICreateSMS } from "../../../redux/types/SMSTypes";

import "../modal/Modal.css";
import "./AddMessageModal.css";

interface IAddSMSModalProps {
  isActive: boolean;
  setIsActive: (value: boolean) => void;
  selectedUserIds: string[];
}

const AddSMS: FC<IAddSMSModalProps> = ({
  isActive,
  setIsActive,
  selectedUserIds,
}) => {
  const [content, setContent] = useState("");
  const [errorLabel, setErrorLabel] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const dispatch = useAppDispatch();

  const operatorId = useAppSelector(
    (state) => state.operator.operator?.id ?? "",
  );

  const onCreateClick = async (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setErrorLabel("");
    setSuccessMessage("");

    if (!content.trim()) {
      setErrorLabel("Введите текст сообщения");
      return;
    }

    if (!operatorId) {
      setErrorLabel(
        "Не удалось определить текущего пользователя (operatorId).",
      );
      return;
    }

    if (selectedUserIds.length === 0) {
      setErrorLabel("Выберите хотя бы одного получателя.");
      return;
    }

    const dto: ICreateSMS = {
      recipientsId: selectedUserIds,
      operatorId,
      content,
    };

    try {
      const result = await dispatch(addSMS(dto));

      if (result) {
        setSuccessMessage("SMS успешно отправлены");
        setContent("");
        setIsActive(false);
      } else {
        setErrorLabel("Не удалось отправить SMS");
      }
    } catch (err: any) {
      setErrorLabel(err?.message ?? "Ошибка при отправке SMS");
    }
  };

  return (
    <div
      id="add-message-modal"
      className={`modal ${isActive ? "modal-active" : ""}`}
    >
      <div className="modal-content">
        <div className="modal-header">
          <h2>Новое SMS</h2>
          <button className="back-button" onClick={() => setIsActive(false)}>
            &larr; Назад
          </button>
        </div>

        <div className="modal-body">
          <form id="add-message-form" onSubmit={(e) => e.preventDefault()}>
            <input type="hidden" value={operatorId} />
            <input type="hidden" value={selectedUserIds.join(",")} />

            <input
              type="hidden"
              value={
                selectedUserIds.length
                  ? selectedUserIds.join(", ")
                  : "Клиенты не выбраны"
              }
              readOnly
            />

            <label className="sms-label">Текст SMS</label>

            <textarea
              placeholder="Сообщение"
              value={content}
              onChange={(e: ChangeEvent<HTMLTextAreaElement>) =>
                setContent(e.target.value)
              }
            />

            {errorLabel && <p className="error-label">{errorLabel}</p>}
            {successMessage && (
              <p className="success-label">{successMessage}</p>
            )}

            <div className="search-box">
              <button onClick={onCreateClick}>Отправить SMS</button>

              <button onClick={() => setIsActive(false)}>Отмена</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddSMS;
